import { ProfilePage } from "@/interface/pages/profile-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_active-subscription/users/profile")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ProfilePage />;
}
